export default {
    PtImagePanel: {
        page: '整頁瀏覽',
        image: '單圖瀏覽',
    },
};
